/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';

import TM24 from './TM24';
import { IOrder } from '@/interfaces/order';
import { ICndn } from '@/interfaces/cndn';
import TM25 from './TM25';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  order: Partial<IOrder>;
  cndn: Partial<ICndn>;
  tms: string[];
}

const PrintModal = ({ open, handleCancel, cndn, tms, order }: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${cndn?.code}`,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          {tms.includes('TM26') && (
            <TM24 data={order as IOrder} cndn={cndn as ICndn} />
          )}
          {tms.includes('TM26') && (
            <TM25 data={order as IOrder} cndn={cndn as ICndn} />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
